import template from './template.html'

export default [directive]

const RATING_TYPES_DEFAULT = require('./types.json')

const ENDORSEMENT_TYPE = 'endorsement'
const RATING_TYPE = 'numeric_rating'

const updateFeature = (feature, settings) => {
  if (settings.config.type === ENDORSEMENT_TYPE) {
    const { endorsements = [] } = settings.config
    Object.assign(
      feature,
      {
        numeric_rating: undefined,
        min: undefined,
        max: undefined,
        units: undefined,
      },
      {
        endorsement:
          Array.isArray(endorsements) && endorsements.length > 0
            ? endorsements[0]
            : '',
        type: ENDORSEMENT_TYPE,
        additional_properties: Object.assign(feature.additional_properties, {
          uiType: settings.type,
        }),
      }
    )
  }
  if (settings.config.type === RATING_TYPE) {
    Object.assign(
      feature,
      {
        endorsement: undefined,
      },
      {
        type: RATING_TYPE,
        numeric_rating: settings.config.max,
        min: settings.config.min,
        max: settings.config.max,
        units: settings.config.units,
        additional_properties: Object.assign(feature.additional_properties, {
          uiType: settings.type,
        }),
      }
    )
  }
}

function directive() {
  return {
    require: '^composeBody',
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      feature: '=',
    },
    controller: ['$rootScope', Controller],
    link: Link,
  }
}

function Link(scope, elem, attrs, controller) {
  controller.registerPropertyValidator(RATING_TYPE, scope.vm.isValid)
  controller.registerPropertyValidator(ENDORSEMENT_TYPE, scope.vm.isValid)
  scope.vm.composeBodyController = controller
}

function Controller($rootScope) {
  this.$onDestroy = () => {
    if (this.composeBodyController) {
      this.composeBodyController.registerPropertyValidator(RATING_TYPE, null)
      this.composeBodyController.registerPropertyValidator(
        ENDORSEMENT_TYPE,
        null
      )
    }
  }

  const selectType = (uiType) => {
    if (!Array.isArray(this.ratingTypes) || this.ratingTypes.length === 0) {
      return
    }
    this.selectedType =
      this.ratingTypes.find((ratingType) => ratingType.type === uiType) ||
      this.ratingTypes[0]
    this.feature.additional_properties.uiType = this.selectedType.type
    updateFeature(this.feature, this.selectedType)
  }

  this.$onInit = () => {
    const ratingTypes =
      $rootScope.globalSettings.ratingTypes || RATING_TYPES_DEFAULT
    this.ratingTypes = ratingTypes
    this.ratingTypesDropdown = ratingTypes.map((ratingType) => ratingType.type)
    selectType(this.feature.additional_properties.uiType)
  }

  this.updateUIType = () => {
    selectType(this.feature.additional_properties.uiType)
  }

  this.isValid = (feature) => {
    if (this.feature.type === RATING_TYPE) {
      return (
        this.feature.min <= this.feature.numeric_rating &&
        this.feature.max >= this.feature.numeric_rating &&
        !isNaN(+this.feature.numeric_rating)
      )
    }

    if (this.feature.type === ENDORSEMENT_TYPE) {
      return this.feature.endorsement && this.feature.endorsement.length > 0
    }
  }
}
